// assets/nd-export-auto-clear.js
// v5 - Export File 後延遲清空購物車，並通知 Clear cart 腳本「這次不用跳確認」

(function () {
  if (window.__ND_EXPORT_AUTO_CLEAR_V5__) return;
  window.__ND_EXPORT_AUTO_CLEAR_V5__ = true;

  function log() {
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[ND Export Auto Clear v5]');
    console.info.apply(console, args);
  }

  var MAX_TRIES = 50;   // 最多試 50 次
  var INTERVAL = 200;   // 每 200ms 試一次（約 10 秒）
  var tries = 0;

  var timer = setInterval(function () {
    tries++;
    var exportBtn = document.getElementById('nd-export-both');

    if (exportBtn) {
      clearInterval(timer);
      log('found export button after', tries, 'tries');
      attachHandler(exportBtn);
      return;
    }

    if (tries >= MAX_TRIES) {
      clearInterval(timer);
      console.warn('[ND Export Auto Clear v5] 找不到 #nd-export-both（試了 ' + tries + ' 次）');
    }
  }, INTERVAL);

  function attachHandler(exportBtn) {
    var clearLink = document.getElementById('clear-cart-link');

    log('attachHandler', { hasExportBtn: !!exportBtn, hasClearLink: !!clearLink });

    exportBtn.addEventListener('click', function () {
      var delayMs = 4000; // 匯出後幾秒清空，自己調

      log('Export File clicked, will clear cart in ' + (delayMs / 1000) + 's');

      setTimeout(function () {
        log('delay reached, start clearing cart...');

        // 告訴 Clear cart 腳本：這一次是「自動清空」，請略過確認視窗
        window.__ND_CLEAR_SKIP_CONFIRM__ = true;

        // 1️⃣ 優先沿用你原本 clear cart 的邏輯（會順便清 localStorage / attributes）
        if (clearLink) {
          try {
            var evt = new MouseEvent('click', {
              bubbles: true,
              cancelable: true,
              view: window
            });
            clearLink.dispatchEvent(evt);
            log('dispatched click to #clear-cart-link (skipConfirm=true)');
          } catch (e) {
            console.error('[ND Export Auto Clear v5] 點擊 #clear-cart-link 失敗', e);
          }
        } else {
          console.warn('[ND Export Auto Clear v5] 沒有找到 #clear-cart-link，改用 /cart/clear.js');
        }

        // 2️⃣ 保險：再打一次 Shopify 官方清空 API
        try {
          fetch('/cart/clear.js', {
            method: 'POST',
            credentials: 'same-origin'
          })
            .then(function () {
              log('cart/clear.js finished, reloading page');
              window.location.reload();
            })
            .catch(function (e) {
              console.error('[ND Export Auto Clear v5] fetch(/cart/clear.js) 失敗', e);
            });
        } catch (e) {
          console.error('[ND Export Auto Clear v5] 呼叫 /cart/clear.js 例外', e);
        }
      }, delayMs);
    });
  }
})();
